module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre2"
  }, [_vm._v("GENTLEMEN FORMERLY DRESSED")]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_vm._v("The Fifth Rowland Sinclair Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“This book has it all: intrigue among the British aristocracy, the Nazi threat and a dashing Australian hero. I didn’t want it to end!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("—Rhys Bowen, author of the "), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("New York Times ")]), _vm._v("bestselling "), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("Royal Spyness ")]), _vm._v("and Molly Murphy mysteries, and the #1 Kindle bestseller, "), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("In Farleigh Field ")]), _vm._v("on "), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("Gentlemen Formerly Dressed")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“Rowland’s determined attempts to open British eyes to the gathering storm combine mystery, rousing adventure, and chance meetings with eminent figures from Churchill to Evelyn Waugh.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“The pleasure of this novel lies...in observing Rowland at dinner with Evelyn Waugh, trading insights with H.G. Wells, and setting Winston Churchill straight on the evils of nationalism. Fans of upper-class sleuths will be in their element.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre10"
  }, [_c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/image/Image33212_fmt.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "calibre2"
  }, [_vm._v("PAVING THE NEW ROAD")]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_vm._v("The Fourth Rowland Sinclair Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_vm._v("Shortlisted for the Davitt Award for Best Adult Crime Fiction for 2013")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre12"
  }, [_vm._v("“The combination of famous historical figures, detailed descriptions of a troubling time, and plenty of action makes for a tale as rousing as it is relevant.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre13"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre12"
  }, [_vm._v("“This installment takes the aristocratic Sinclair into a much darker place than did the previous three entries in the series but does so without losing the stylish prose and the easy way with character that have given the novels their appeal.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre12"
  }, [_vm._v("“... stylish, well-paced murder mystery... cheeky plotline... this tale is told with such flair and feeling for those extraordinary times... Verdict: thrilling”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("The Herald Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre10"
  }, [_c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/image/Image33212_fmt.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "calibre2"
  }, [_vm._v("MILES OFF COURSE")]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_vm._v("The Third Rowland Sinclair Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“Gentill’s third reads like a superior Western, alternating high adventure with social and political observations about prewar Australia.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“Set in Australia in 1933, Gentill’s entertaining third mystery featuring portrait artist Rowland Sinclair will appeal to fans of Greenwood’s Phryne Fisher ... Gentill matches Greenwood’s skill at blending suspense with a light touch.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“Rowland is an especially interesting character: at first he comes off as a bit of a layabout, a guy who feels he’s entitled to a cushy life by virtue of his aristocratic roots, but, as the story moves along, we realize he has a strong moral center and a compulsion to finish a job once he’s started it. A great addition to a strong series and a fine read-alike for fans of Kerry Greenwood’s Phryne Fisher novels.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre10"
  }, [_c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/image/Image33212_fmt.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "calibre2"
  }, [_vm._v("A DECLINE IN PROPHETS")]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_vm._v("The Second Rowland Sinclair Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_vm._v("Winner of the Davitt Award for Best Adult Crime Fiction for 2012")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre12"
  }, [_vm._v("“I thoroughly enjoyed the glamour of the ocean voyage, the warmth and wit among the friends, and yet all the time, simmering beneath the surface, was the real and savage violence, waiting to erupt. The 1930s are a marvelous period. We know what lies ahead! This is beautifully drawn, with all its fragile hope and looming tragedy. I am delighted this is a series. I want them all.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_vm._v("—Anne Perry"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v(", New York Times ")]), _vm._v("bestselling author")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _c('p', {
    staticClass: "calibre12"
  }, [_vm._v("“Set in late 1932, Gentill’s lively second mystery featuring dashing Australian millionaire Rowland “Rowly” Sinclair takes place initially aboard the luxury cruise ship Aquitania, as it steams along toward Sydney … The witty and insightful glimpses of the Australian bourgeoisie of this period keep this mystery afloat.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre17"
  }, [_vm._v("“A delightful period piece.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre18"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre17"
  }, [_vm._v("“...the start of a promising new series set in 1930s Sydney about a character who is a little like a male Phryne Fisher. Rowland Sinclair is a gentleman artist who comes from a privileged background but whose sympathies are with bohemians, lefties and ratbags. It's a rich political and cultural era to explore and Gentill has a lot of fun with a hero who is always getting paint on his immaculate tailoring.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre18"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("The Sydney Morning Herald")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre10"
  }, [_c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/image/Image33212_fmt.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "calibre2"
  }, [_vm._v("A FEW RIGHT THINKING MEN")]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_vm._v("The First Rowland Sinclair Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_vm._v("Shortlisted for Best First Book for the Commonwealth Writers' Price for 2011")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“Fans of Kerry Greenwood’s Phryne Fisher series, rejoice: here comes another Depression-era Australian sleuth! Along the way there is plenty of solid discussion of politics and social status, with enough context to both draw in those new to the era and keep those more well-versed in their history interested.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre19"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Historical Novel Society")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“As series-launching novels go, this one is especially successful: the plot effectively plays Sinclair’s aristocratic bearing and involvement in the arts against the Depression setting, fraught with radical politics, both of which he becomes involves in as he turns sleuth. And Sinclair himself is a delight: wining us over completely and making us feel as though he’s an old friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre20"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Booklist")]), _vm._v(" (starred review)")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“While the vintage Down Under settings might make this debut, which was short-listed for the Commonwealth Writers’ Prize Best First Book, comparable to Kerry Fisher’s Melbourne-based Phryne Fisher 1920s mysteries, Gentill works in historical events that add verisimilitude to her story. There are more political machinations going on here than Phryne could ever contemplate. VERDICT: Thanks to Poisoned Pen Press for bringing another award-winning Australian crime writer to U.S. shores. Her witty hero will delight traditional mystery buffs.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Library Journal")]), _vm._v(" (starred review)")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("“It takes a talented writer to imbue history with colour and vivacity... "), _c('i', {
    staticClass: "calibre21"
  }, [_vm._v("A Few Right Thinking Men")]), _vm._v(" more than matches its historical crime contemporaries... It is rare to find such an assured debut as "), _c('i', {
    staticClass: "calibre21"
  }, [_vm._v("A Few Right Thinking Men")]), _vm._v(". The novel deserves to be both read and remembered as an insight into the Australia that was; its conflicting ideologies, aims and desires; the hallmarks of a country still maturing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre20"
  }, [_vm._v("—"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Australian Book Review")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7256ed0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ReviewPage.vue
// module id = 63
// module chunks = 0